import React, {ReactNode} from 'react';

import Menu from 'shared/ui/icons/Menu';

import cn from 'classnames';

import MoreActions from './MoreActions';

import styles from './MoreActions.module.scss';

type Placement =
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'topStart'
    | 'topEnd'
    | 'bottomStart'
    | 'bottomEnd'
    | 'leftStart'
    | 'leftEnd'
    | 'rightStart'
    | 'rightEnd'
    | 'auto'
    | 'autoVertical'
    | 'autoHorizontal';

interface IMoreActionsDotsProps {
    children: ReactNode | null |undefined,
    vertical?: boolean,
    placement?: Placement;
}

const MoreActionsDots: React.FC<IMoreActionsDotsProps> = ({children, vertical, placement = 'bottomEnd'}) => {

    const anchor = <div className={cn(
        vertical && styles.vertical,
        styles['more'],
    )}>
        <Menu/>
    </div>;

    return (
        <MoreActions
            anchor={anchor}
            placement={placement}
        >
            {children}
        </MoreActions>
    );
};

export default React.memo(MoreActionsDots);